import type { ACL as ACLData } from '~/store/user/http/types'
import type { ModuleLevel } from '~/codebooks/acl/ModuleLevel'
import type { PrivilegeLevel } from '~/codebooks/acl/PrivilegeLevel'

export class ACL {
  constructor(
    public readonly modules: string[],
    public readonly modulesLevel: ModuleLevel,
    public readonly privileges: string[],
    public readonly privilegesLevel: PrivilegeLevel,
  ) {}

  static fromResponseData(data: ACLData): ACL {
    return new ACL(data.modules, data.modulesLevel, data.privileges, data.privilegesLevel)
  }
}
